exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video[data-v-125bda31]{width:300px;height:300px}.upload-wrapper[data-v-125bda31]{position:relative;margin-right:15px}.upload-wrapper .upload-file-cn[data-v-125bda31]{position:absolute;height:33px;opacity:0;border:none}.upload-wrapper .upload-file-en[data-v-125bda31]{position:absolute;height:33px;opacity:0;border:none}.upload-wrapper .upload-file-ja[data-v-125bda31]{position:absolute;height:33px;opacity:0;border:none}\n", ""]);

// exports
